module.exports = __webpack_public_path__ + "static/notifications-868904e375348524f0327767a5307da3.png";